<template>
  <LibraryLayout :title="'Lesson Library'" :items="lessons">
    <template slot="button">
      <v-btn v-if="authUser" @click="createLesson" color="purple" dark class="elevation-0">
        <v-icon left>mdi-creation-outline</v-icon> Create Lesson
      </v-btn>
      <v-btn v-else @click="go('LoginView')" color="purple" dark class="elevation-0">
        <v-icon left>mdi-lock-outline</v-icon> Create Lesson
      </v-btn>
    </template>
    <template #card="{ item: lesson }">
      <v-card class="ma-2" width="300" @click="go('LessonPlayer', lesson.id)">
        <v-img :src="lesson.thumbnail" color="grey lighten-4" height="200"></v-img>
        <v-divider></v-divider>
        <div class="px-4 pt-4 cal-sans-regular font-size-20">{{ lesson.title }}</div>
        <div class="d-flex flex-row align-center px-4 pb-4 pt-2">
          <v-avatar size="30">
            <v-img src="@/assets/babyboomy.png"></v-img>
          </v-avatar>
          <p class="ma-0 ml-2">Baby Boomy</p>
        </div>
      </v-card>
    </template>
  </LibraryLayout>
</template>

<script>
import { getDocs, collection } from 'firebase/firestore'
import { db } from '@/firebase/init'
import LibraryLayout from '@/layouts/Library.vue'
export default {

  name: 'LessonLibrary',
  
  components: { LibraryLayout },

  data() {
    return {
      lessons: [],
      progress: 0,
    }
  },

  created() {
    this.loadLessons()
  },

  methods: {
    loadLessons() {
      this.progress = 0
      const lessonsRef = collection(db, 'lessons')
      getDocs(lessonsRef).then((snapshot) => {
        snapshot.forEach((doc) => {
          let lesson = doc.data()
          lesson.id = doc.id
          this.lessons.push(lesson)
        })
        this.progress = 100
      })
    },
    async createLesson() {
      if (this.authUser) {
        await this.$creator.create('lesson', this.profile);
      }
    }
  }
}
</script>

<style scoped>

</style>